export default "__VITE_ASSET__Dln4uxKL__"